import React from 'react'

const InvalidPath = () => {
  return (
    <div>InvalidPath</div>
  )
}

export default InvalidPath